import { Helmet } from 'react-helmet-async';
import { Typography } from '@mui/material';

import DealerRequiredPageShell from 'app/components/ReusableUIComponents/HighLevelComponents/DealerRequiredPageShell';
import { withResourceProtection } from 'app/components/ReusableUIComponents/HOCs/ResourceProtected/withResourceProtection';
import { DealerSegmentSettingsComponent } from 'app/pages/DealerSegmentSettingsComponent/Loadable';
import { CONFIGURE_RESOURCE_SEGMENTS } from 'app/pages/ConfigurePage/utils/configureResourceIds';

import { useSegmentsConfigurationPage } from './hooks/useSegmentsConfigurationPage';

const SegmentsConfigurationPage = () => {
  const { breadcrumbsList, hasDealer, dealerTitle, dealerId } =
    useSegmentsConfigurationPage();

  return (
    <>
      <Helmet>
        <title>Segments configuration</title>
        <meta
          name="description"
          content="Configure dealer segment settings for the selected dealership"
        />
      </Helmet>
      <DealerRequiredPageShell
        hasDealer={hasDealer}
        breadcrumbsList={breadcrumbsList}
        pageTitle="Dealer segment settings"
        headerSubtitle={
          hasDealer ? (
            <Typography variant="subtitle1" color="text.secondary">
              {dealerTitle ? `${dealerTitle} (${dealerId})` : dealerId}
            </Typography>
          ) : undefined
        }
        contentVariant="centered"
      >
        <DealerSegmentSettingsComponent defaultExpanded />
      </DealerRequiredPageShell>
    </>
  );
};

export default withResourceProtection(
  SegmentsConfigurationPage,
  CONFIGURE_RESOURCE_SEGMENTS,
);
